import Pusher from 'pusher-js';
import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { isEligibleForPreOrder } from '../../functions/isEligibleForPreOrder';
import { isPaymentPending } from '../../functions/isPaymentPending';
import { activeOrder, infotip } from '../../paths/defaultImage';
import Button from '../common/buttons/Button';
import '../../css/footer.css';
import { useTranslation } from 'react-i18next';
import LazyImage from '../common/lazyLoad';
const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
  cluster: 'ap1',
  encrypted: true,
});

const FooterCarosol = ({ viewOrderStatus, previousOrders, getCart, globalSetting }) => {
  const { t } = useTranslation();
  const findUniqueOrderIds = {};
  const [pusherMessage, setPusherMessage] = useState(null);

  const footerOrderList = previousOrders.map((item, index) => {
    const isEnabled = isEligibleForPreOrder(
      globalSetting?.enable_pre_paid_order,
      globalSetting?.pre_paid_order,
      item?.order_type
    );
    let prePaidOrderEnabled = {
      ...isEnabled,
      payLaterEnabledFromShannon: globalSetting?.takeaway_cash_enable,
    };

    if (!findUniqueOrderIds[item.order_id]) findUniqueOrderIds[item.order_id] = true;
    const is_payment_pending = isPaymentPending(item, prePaidOrderEnabled);

    return (
      <Carousel.Item key={item.order_id} className='item-carousel'>
        <div className='activeOrderCarousel' onClick={() => viewOrderStatus(index)}>
          <div
            className={`d-flex w-100 cursor-pointer ${
              previousOrders.length > 1 ? 'carousel-text-pad' : 'carousel-pading'
            } fw-600 justify-content-between align-items-center`}>
            <div className='pr-2 d-flex flex-row'>
              <LazyImage
                src={activeOrder}
                className='active-order-img'
                alt='active order'
                height='25px'
                width='41px'
              />
            </div>
            <div className='flex-3'>
              <div className='fs-var'>
                <div className='blur-none'>
                  {' '}
                  {!is_payment_pending
                    ? ` ${t('my_order')} #${item?.order_seq} ${t('is_running')}`
                    : `#${item?.order_seq} |  ${t('payment_pending')}`}{' '}
                </div>
                {is_payment_pending ? (
                  <div className='fs-10-var red-text'>
                    <LazyImage
                      src={infotip}
                      alt='info'
                      height='12px'
                      width='12px'
                      className='mr-1 mar-variable blur-none'
                    />
                    {t('pay_pre')}
                  </div>
                ) : null}
              </div>
            </div>
            <div className='flex-1 text-view blur-none'>
              <Button text={t('view')} type='primary fs-12 fw-400 btn-medium' />
            </div>
          </div>
        </div>
      </Carousel.Item>
    );
  });

  const orderIds = Object.keys(findUniqueOrderIds);
  useEffect(() => {
    if (!orderIds?.length) return;
    pusher.connection.bind('state_change', function (states) {
      console.log(`%cPusher:${states?.current}`, 'color:blue;font-size:20px');
    });
  }, []);
  useEffect(() => {
    orderIds?.forEach((orderId) => {
      const channel = pusher.subscribe(orderId);
      channel.bind('order-event', function (data) {
        setPusherMessage(data);
      });
    });
  }, [orderIds?.length]);

  useEffect(() => pusherMessage && getCart(), [pusherMessage]);
  return (
    <>
      <Carousel
        className='footerCar'
        controls={false}
        indicators={previousOrders.length > 1 ? true : false}>
        {footerOrderList}
      </Carousel>
    </>
  );
};

export default FooterCarosol;
